import { useEffect } from "react";

export const useIntersectionObserver = ({
  callback,
  ref,
  root = null,
  threshold = 0.5,
  viewTimeSeconds = 1
}) => {
  useEffect(() => { // NOSONAR
    let timerId = null;

    const observer = new IntersectionObserver((entries, intersectionObserver) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          if (timerId !== null) {
            clearTimeout(timerId);
          }
          timerId = setTimeout(() => {
            if (callback) {
              callback(entry);
            }
            intersectionObserver.unobserve(entry.target);
          }, viewTimeSeconds * 1000);
        }

        if (!entry.isIntersecting && timerId !== null) {
          clearTimeout(timerId);
          timerId = null;
        }
      });
    }, { root, threshold });

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      if (timerId !== null) {
        clearTimeout(timerId);
      }
      observer.disconnect();
    };
  }, [callback, root, threshold, viewTimeSeconds]);
};
